import enUsDefaultEmailTemplate from "./en-US";
import esMxDefaultEmailTemplate from "./es-MX";
import ptBrDefaultEmailTemplate from "./pt-BR";

export const defaultEmailTemplate = {
  "pt-BR": ptBrDefaultEmailTemplate,
  "en-US": enUsDefaultEmailTemplate,
  "es-MX": esMxDefaultEmailTemplate,
};
